import React, { useRef } from "react";
import useTranslation from "next-translate/useTranslation";
import { Col, Row } from "antd";
import { useCountUp } from "react-countup";

const TheNumber = () => {
  const { t } = useTranslation("about-us");

  const follower = useRef(null);
  const trainer = useRef(null);
  const member = useRef(null);
  const course = useRef(null);

  const TIME_OUT_LOOP = 3000;

  const DATA_MOCKUP = [
    {
      key: 1,
      number: 55000,
      title: "Người theo dõi",
      start: 550,
      ref: follower,
    },
    {
      key: 2,
      number: 60,
      title: "Người hướng dẫn",
      start: 10,
      ref: trainer,
    },
    {
      key: 3,
      number: 11000,
      title: "Thành viên",
      start: 110,
      ref: member,
    },
    {
      key: 4,
      number: 215,
      title: "Khoá học hoàn thành",
      start: 20,
      ref: course,
    },
  ];

  return (
    <div className="number">
      <div className="number__content">
        <h3>
          {t("number.title")}
          <span />
        </h3>

        <Row gutter={[10, 20]}>
          {DATA_MOCKUP?.map((item) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const { start } = useCountUp({
              ref: item?.ref,
              start: item?.start,
              end: item?.number,
              duration: 1,
              onEnd: () => setTimeout(() => start(), TIME_OUT_LOOP),
            });

            return (
              <React.Fragment key={item?.key}>
                <Col xl={6} sm={12} xs={24} className="item">
                  <div className="number__content__box">
                    <span ref={item?.ref} />
                    <p>{item?.title}</p>
                  </div>
                </Col>
              </React.Fragment>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default TheNumber;
